angular.module 'zc.core'

.directive "confirmModal", ($translate, $window) ->
  scope:
    suppressConfirm: '='
    confirmClick: '&'
  link: (scope, element, attr) ->
    element.bind "click", (event) ->
      msg = attr.confirmModal or $translate.instant('sharedModules.core.directives.confirmModal')

      isElementDisabled = _.get(attr, 'disabled', false) == "true" || element[0].classList.contains('disabled')
      return if isElementDisabled

      if scope.suppressConfirm
        scope.confirmClick()
      else
        scope.confirmClick() if $window.confirm(msg)



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/directives/confirm_modal.js.coffee